/**
 * @generated SignedSource<<3d73a7099a9295c02951eb57579b7d93>>
 * @relayHash a7e48eaea1f1087c0622f1648327271d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_rightSidePanel_RootQuery$variables = {
  broadcastWidgetEnabled: boolean;
  cloudId: string;
};
export type main_rightSidePanel_RootQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_homeBroadcastWidget_Widget">;
};
export type main_rightSidePanel_RootQuery = {
  response: main_rightSidePanel_RootQuery$data;
  variables: main_rightSidePanel_RootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "broadcastWidgetEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_rightSidePanel_RootQuery",
    "selections": [
      {
        "condition": "broadcastWidgetEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "main_homeBroadcastWidget_Widget"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "main_rightSidePanel_RootQuery",
    "selections": [
      {
        "condition": "broadcastWidgetEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                  }
                ],
                "concreteType": "JiraUserBroadcastMessageConnection",
                "kind": "LinkedField",
                "name": "allJiraUserBroadcastMessages",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraUserBroadcastMessageEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraUserBroadcastMessage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "shouldDisplay"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1",
    "metadata": {},
    "name": "main_rightSidePanel_RootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "174d1e9e3edb60b5684e0806b3d7342e";

export default node;
